import React from "react";

function Add() {
  return (
    <svg
      role="img"
      height="12"
      width="12"
      viewBox="0 0 16 16"
      class="Svg-ulyrgf-0 hJgLcF"
    >
      <path d="M14 7H9V2H7v5H2v2h5v5h2V9h5z"></path>
      <path fill="none" d="M0 0h16v16H0z"></path>
    </svg>
  );
}

export default Add;
